'use strict'

import axios from 'axios'

export const http = axios.create()

export default http
